import { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthPage from "./pages/AuthPage";
import RequestsPage from "./pages/RequestsPage";
import PlaylistsPage from "./pages/PlaylistsPage";
import PromotionsPage from "./pages/PromotionsPage";
import PaymentsPage from "./pages/PaymentsPage";
import DeleteProfilePage from "./pages/DeleteProfilePage";
import VenuesPage from "./pages/VenuesPage";
import UsersPage from "./pages/UsersPage";
import DJsPage from "./pages/DJsPage";
import AdminsPage from "./pages/AdminsPage";
import EventsPage from "./pages/EventsPage";
import KaraokePage from "./pages/KaraokePage";
import NotificationsPage from "./pages/NotificationsPage";
import EmailsPage from "./pages/EmailsPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PrivateRoute from "./PrivateRoute";
import AdminRoute from "./AdminRoute";
import LibraryPage from "./features/library/pages/LibraryPage";
import UserContext from "./contexts/UserContext";

function App() {
  const userContext = useContext(UserContext);
  const isAuthenticated = Boolean(userContext.user?.userId);

  return (
    <Routes>
      <Route
        path="/"
        exact
        element={<Navigate to={isAuthenticated ? "/events" : "/login"} replace />}
      />
      <Route
        path="/login"
        exact
        element={
          isAuthenticated ? <Navigate to="/events" replace /> : <AuthPage title="Log in" />
        }
      />
      <Route
        path="/register"
        exact
        element={
          isAuthenticated ? <Navigate to="/events" replace /> : <AuthPage title="Sign up" />
        }
      />
      <Route
        path="/forgottenpassword"
        exact
        element={<AuthPage title="Forgotten Password" />}
      />
      <Route
        path="/resetpassword"
        exact
        element={<AuthPage title="Reset Password" />}
      />
      <Route
        path="/requests/:eventId"
        exact
        element={
          <PrivateRoute>
            <RequestsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/playlists/:eventId"
        exact
        element={
          <PrivateRoute>
            <PlaylistsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/promotions"
        exact
        element={
          <PrivateRoute>
            <PromotionsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/payments"
        exact
        element={
          <PrivateRoute>
            <PaymentsPage />
          </PrivateRoute>
        }
      />
      <Route path="/deleteprofile" exact element={<DeleteProfilePage />} />
      <Route
        path="/venues"
        exact
        element={
          <PrivateRoute>
            <VenuesPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        exact
        element={
          <PrivateRoute>
            <UsersPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/djs"
        exact
        element={
          <PrivateRoute>
            <DJsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admins"
        exact
        element={
          <PrivateRoute>
            <AdminsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/events"
        exact
        element={
          <PrivateRoute>
            <EventsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/karaoke"
        exact
        element={
          <PrivateRoute>
            <KaraokePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/library"
        exact
        element={
          <PrivateRoute>
            <LibraryPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/notifications"
        exact
        element={
          <PrivateRoute>
            <AdminRoute>
              <NotificationsPage />
            </AdminRoute>
          </PrivateRoute>
        }
      />
      <Route
        path="/emails"
        exact
        element={
          <PrivateRoute>
            <AdminRoute>
              <EmailsPage />
            </AdminRoute>
          </PrivateRoute>
        }
      />
      <Route path="/termsofuse" exact element={<TermsOfUsePage />} />
      <Route path="/privacypolicy" exact element={<PrivacyPolicyPage />} />
    </Routes>
  );
}

export default App;
